import { asyncRouterMap, constantRouterMap } from '@/router';

/**
 * 通过meta.sign判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(role, route) {
  return true // TODO: 暂且关闭，路由权限校验
  if (route.meta && route.meta.sign) {
    return role.indexOf(route.meta.sign) != -1;
  } else {
    return true; // 没有配置meta，默认都有权限
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路addRouters由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, permission) {
  // 动态添加的路由，要根据权限过滤过滤出可用的路由
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(permission, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, permission);
      }
      return true;
    }
    return false;
  });
  return accessedRouters;
}


const permission = {
  state: {
    routers: constantRouterMap,// 所有的路由
    addRouters: [] // 异步添加的routes
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise((resolve, reject) => {
        try {
          // 通过role过滤符合的动态路由
          let addRouters = filterAsyncRouter(asyncRouterMap, data.permission);
          // state中保存动态路由数组
          commit('SET_ROUTERS', addRouters);
          resolve(addRouters);
        } catch (err) {
          reject(err);
        }
      });
    }
  }
};

export default permission;
